import React, { useContext } from 'react';
import { Table } from 'components';
import { dataGridModel } from 'keys';
import { TablePageStyles } from 'styles/GlobalStyle'
import { CreatePracticesContext } from './CreatePracticesContext';
import { createPracticeHooks } from '.';

const TestTakers = () => {
    const { searchVal, setSearchVal, testTakers, testTakersOptions, page, setPage, pageSize, setPageSize, sorting, setSorting } = useContext(CreatePracticesContext)

    const columns = createPracticeHooks.useTableColumns()

    return (
        <TablePageStyles>
            <Table
                withTitle
                loading={testTakers.isFetching && !testTakers.data}
                data={testTakers.data}
                columns={columns}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                rowKey={"test_taker_id"}
                visibilityModelKey={dataGridModel.test_takers}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
                sorting={sorting}
                setSorting={setSorting}
                queryKey={testTakersOptions.queryKey}
            // onRowSelection={setRowSelectionModel}
            />
        </TablePageStyles>
    )
}

export default TestTakers
